import { Side } from '@/common/constants.ts';
import { useHeartbeatStore } from '@/common/heartbeatStore.ts';
import type { MarketData } from '@/common/MarketData.ts';
import type { OrderFormData } from '@/feature/order_entry/order_schema.ts';
import useAppStore from '../../../store/rootStore.ts';
import { NO_EXPIRY_BLOCK } from '../../../types/SmartContractTypes.ts';

export function getMarketDataById(marketId: number): MarketData | undefined {
  return useAppStore.getState().markets.get(marketId);
}

export function getMarketSymbol(marketId?: number | null): string {
  if (marketId == null) return '';
  const market = useAppStore.getState().markets.get(marketId);
  return market?.symbol || '';
}

export interface OrderMessageParts {
  marketId?: number | null;
  side: Side;
  isClose?: boolean;
  orderType: string;
  size: number | string | undefined;
  price: number | string | undefined;
}

export function buildOrderBaseMessage(parts: OrderMessageParts): string {
  const sideText = parts.side === Side.long ? 'Long' : 'Short';
  const closeText = parts.isClose ? 'Close ' : '';
  const orderTypeText = parts.orderType;
  const marketSymbol = getMarketSymbol(parts.marketId);
  const symbolText = marketSymbol ? `${marketSymbol} ` : '';
  const priceText = parts.price != null ? ` at ${parts.price}` : '';

  return `${symbolText}${closeText}${sideText} ${orderTypeText} order ${parts.size}${priceText}`;
}

export function calculateExpiryBlock(orderTtlBlocks?: number): bigint {
  const currentBlock = BigInt(useHeartbeatStore.getState().trading.headBlockNumber ?? 0);
  return currentBlock ? currentBlock + BigInt(orderTtlBlocks ?? 10) : NO_EXPIRY_BLOCK;
}

/** Rough USD value of a form order, for telemetry only. */
export function estimateOrderValueUsd(formData: OrderFormData, market: MarketData): number {
  if (!market) return 0;

  const size = parseFloat(formData.size || '0');
  if (formData.sizeUnit === 'quote') {
    return size;
  } else {
    const price = formData.price ? parseFloat(formData.price) : market.midPrice || 0;
    return size * price;
  }
}
